import { useSelector } from "react-redux";
import { getLoggedInUser } from 'redux/selectors';

import eventsHeader from '../sass/navigation.module.scss'

function EventsHeader (props) {
  const loggedInUser = useSelector(getLoggedInUser);
  return (
    <>
    {loggedInUser && !loggedInUser.crmUser &&
      <div className={eventsHeader.container}>
        <button className={eventsHeader['return-link']} onClick={() => window.close()}>Continue as Guest</button>
      </div>}
    {(!loggedInUser || loggedInUser.crmUser) &&
      <div className={eventsHeader.container}>
        <button className={eventsHeader['return-link']} onClick={() => window.close()}>Return to UCLA Events</button>
      </div>}
    </>
  )
}

export default EventsHeader;

